import { z } from 'zod';
import { SHOW_ORG_LOGO_CHOICES } from '../../lib/show-org-logo';
import { consentConfigSchema } from '../../lib/consent-fields';

// Strict 1:1 template↔agent: creating a template always mints a NEW dedicated
// agent (a duplicate of the base agent), then writes this prompt + first message
// onto it. There is no "connect an existing agent" path, so no agent-mode
// discriminator and no caller-supplied agent id — the system prompt is always
// required (a fresh agent is authored from blank).
export const createInterviewTypeFormSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  description: z.string(),
  systemPrompt: z.string().min(1, 'A system prompt is required for a new agent'),
  firstMessage: z.string(),
  // 'none' means "None" — containers map 'none' → undefined before sending to the API
  extractionVersionId: z.string(),
  rubricVersionId: z.string(),
  candidateTitle: z.string().min(1, 'Title is required').max(120),
  candidateDescription: z.string().min(1, 'Description is required').max(2000),
  candidateEndOfCallNotes: z.string().min(1, 'End-of-call notes are required').max(2000),
  candidateDeclinedMessage: z.string().min(1, 'Declined message is required').max(2000),
  candidateShowOrgLogo: z.enum(SHOW_ORG_LOGO_CHOICES),
  consentConfig: consentConfigSchema,
});

export type CreateInterviewTypeFormValues = z.infer<typeof createInterviewTypeFormSchema>;
